export const addUserMessage = (text, displayName, senderId) => ({
  type: "ADD_NEW_USER_MESSAGE",
  payload: { text, displayName, senderId },
});

export const addResponseMessage = (message) => ({
  type: "ADD_NEW_RESPONSE_MESSAGE",
  payload: { message },
});

export const addChatHistory = (chatHistory) => ({
  type: "ADD_CHAT_HISTORY",
  payload: { chatHistory },
});

export const addJoinedMessage = (message) => ({
  type: "ADD_JOINED_MESSAGE",
  payload: { message },
});

export const clearState = () => ({
  type: "CLEAR_STATE",
});
